import { render, staticRenderFns } from "./TrialForm.vue?vue&type=template&id=56936dd5&scoped=true"
import script from "./TrialForm.vue?vue&type=script&lang=js"
export * from "./TrialForm.vue?vue&type=script&lang=js"
import style0 from "./TrialForm.vue?vue&type=style&index=0&id=56936dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56936dd5",
  null
  
)

export default component.exports